import React, { useEffect, useState } from "react";
import { Nav, Navbar, Spinner } from "react-bootstrap";
import { LinkContainer } from "react-router-bootstrap";
import {
    BrowserRouter as Router, Route, Switch, useRouteMatch
} from "react-router-dom";
import { db } from "../../../firebase";
import Season from "./season";


export default function AdminSeasons() {
    var [isloading, setisloading] = useState(true)
    var [allSeasons, setallSeasons] = useState([])

    let match = useRouteMatch()

    function getAllSeasons() {
        setisloading(true)
        db.collection("seasons").get()
            .then((querySnapshot) => {
                var allSeasonsList = []
                querySnapshot.forEach((doc) => {
                    var seasonObj = doc.data()
                    seasonObj.id = doc.id
                    allSeasonsList.push(seasonObj)
                })
                console.log(allSeasonsList)

                setallSeasons(sortSeasons(allSeasonsList))
                setisloading(false)
            })
            .catch((e) => {
                console.log(e)
                setisloading(false)
            })
    }

    function sortSeasons(seasons) {
        /**
         * Sort sessions based on date, and filter out past sessions 
         */

        // var today = new Date();
        // var yesterday = new Date();
        // yesterday.setDate(today.getDate() - 1);
        // console.log(seasons)
        // seasons = seasons.filter((s) => {
        //     const date = new Date(s.enddate)
        //     return date >= yesterday
        // })
        // console.log('yesterday', yesterday)
        // seasons.sort(function (a, b) {
        //     // Turn your strings into dates, and then subtract them
        //     // to get a value that is either negative, positive, or zero.
        //     return new Date(a.enddate) - new Date(b.enddate);
        // });

        // console.log(seasons)
        return seasons
    }

    useEffect(() => {
        getAllSeasons()
    }, [])


    let tabs = (
        allSeasons.map((doc, ind) =>
            <LinkContainer to={`${match.url}/${doc.id}`} key={ind}>
                <Nav.Link>
                    <b>{doc.seasonName}</b>
                </Nav.Link>
            </LinkContainer>
        )
    )

    let seasons = (
        <div id="seasons-container"
            className="full-width">
            <Navbar
                variant="dark"
                className="navbar full-width"
            >
                <Nav className="full-width"
                    navbarScroll>
                    {tabs}
                </Nav>
            </Navbar>
        </div>
    )

    return (
        <div className="full-width">
            <Router className='full-width'>
                <div className="full-width">
                    {isloading ? <Spinner animation="border" role="status">
                        <span className="sr-only">Loading...</span>
                    </Spinner>
                        :
                        seasons}
                </div>
                <Switch className="full-width">
                    <Route path={`${match.url}/:id`}>
                        <Season reloadSeasons={getAllSeasons} />
                    </Route>
                </Switch>
            </Router>
        </div>
    )
}